import React from "react";
import { IconFileText } from "@tabler/icons-react";
import type { DispositionCriterion, DispositionEvidence } from "./types";

type Props = {
  criterion: DispositionCriterion;
  onEvidenceClick?: (evidence: DispositionEvidence) => void;
};

const CriteriaCard: React.FC<Props> = ({ criterion, onEvidenceClick }) => {
  const isQualified = criterion.status === "Qualified";

  return (
    <div
      className={`flex flex-col gap-2.5 rounded-lg border px-3.5 py-3 ${
        isQualified
          ? "border-emerald-200 bg-emerald-50"
          : "border-red-200 bg-red-50"
      }`}
    >
      <div className="flex items-center gap-2.5">
        <span className="flex-1 text-xs font-bold uppercase tracking-wider text-gray-800">
          {criterion.name}
        </span>
        <span
          className={`shrink-0 rounded px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide text-white ${
            isQualified ? "bg-emerald-600" : "bg-red-600"
          }`}
        >
          {isQualified ? "QUALIFIED" : "GATEWAY BARRIER"}
        </span>
      </div>

      {(criterion.evidences ?? []).length > 0 && (
        <div className="flex flex-col gap-2">
          {(criterion.evidences ?? []).map((evidence, index) => (
            <div key={`${evidence.file}-${evidence.page}-${index}`}>
              <div className="mb-1 flex items-center gap-1.5 text-xs font-medium text-gray-600">
                <IconFileText
                  size={14}
                  className="shrink-0 text-indigo-400"
                  aria-hidden
                />
                <span>Clinical Context Extraction</span>
              </div>
              <p className="text-xs italic text-gray-800">
                {evidence.text}
                <button
                  type="button"
                  onClick={() => onEvidenceClick?.(evidence)}
                  className="ml-1 inline font-semibold not-italic text-blue-600 hover:underline"
                >
                  | {evidence.file} - p.{evidence.page}
                </button>
              </p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CriteriaCard;
